import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class ProductSalesGroup extends BaseEntity{
    
    productSalesGroupCode : string;
    name : string;
    rank : number;

}
